import { DateTime } from "luxon";
import { DateTimePicker } from "../datetimepicker/DateTimePicker";
import { FormField } from "./FormField";
import { IFormControl } from "../Form";

interface IFormFieldDateTimePickerProps {
  label?: string;
  formControl: IFormControl<DateTime>;
  selectedDate?: DateTime;
  placeholder?: string;
  className?: string;
  hasMinSelectableDate?: boolean;
  minDate?:DateTime | undefined; 
  maxDate?:DateTime | undefined; 
}

export function FormFieldDateTimePicker(props: IFormFieldDateTimePickerProps) {
  return (
    <FormField label={props.label} formControl={props.formControl}>
      <DateTimePicker
        value={props.formControl.value}
        selectedDate={props.selectedDate}
        onChange={props.formControl.setValue}
        placeholder={props.placeholder}
        className={props.className}
        isDisabled={props.formControl.isDisabled}
        hasError={props.formControl.hasErrors}
        minDate={props.minDate}
        maxDate={props.maxDate}
      />
    </FormField>
  );
}
